import _ from "lodash";
import React, { useState } from "react";
import PickTime from "../../core/pick-time";

const BusinessHour = ({ config }) => {
  const value = _.get(config, "value", []);
  const onChange = _.get(config, "onChange", () => {});

  const [hours, setHours] = useState(value);

  const handleAddTimeRange = () => {
    const newHours = [...hours, { startTime: "00:00", endTime: "00:00", isError: true}];
    setHours(newHours);
    onChange(newHours);
  };

  const parseTimeToMinutes = (time) => {
    const [hour, minute] = time.split(":").map(_.toNumber);
    return hour * 60 + minute;
  };

  const isTimeInRange = (hours, timeInMinutes, index) => {
    return hours.some(({ startTime, endTime }, i) => {
      if (i === index) return false;
      const start = parseTimeToMinutes(startTime);
      const end = parseTimeToMinutes(endTime);
      return timeInMinutes > start && timeInMinutes < end;
    });
  };

  const handleTimeChange = (index, type, time) => {
    const newHours = _.cloneDeep(hours);

    const startTimeStr = type === "endTime"
      ? _.get(newHours[index], "startTime", "00:00")
      : time;

    const endTimeStr = type === "startTime"
      ? _.get(newHours[index], "endTime", "00:00")
      : time;

    const startInMinutes = parseTimeToMinutes(startTimeStr);
    const endInMinutes = parseTimeToMinutes(endTimeStr);

    let isError = false;

    if (startInMinutes >= endInMinutes) {
      isError = true;
    }

    const isStartInOtherRange = isTimeInRange(hours, startInMinutes, index);
    const isEndInOtherRange = isTimeInRange(hours, endInMinutes, index);

    if (isStartInOtherRange || isEndInOtherRange) {
      isError = true;
    }

    newHours[index][type] = time;
    newHours[index]["isError"] = isError;

    setHours(newHours);
    onChange(newHours);
  };

  const handleRemoveTimeRange = (index) => {
    const newHours = hours.filter((_, i) => i !== index);
    setHours(newHours);
    onChange(newHours);
  };

  return (
    <div className="p-3 rounded-2 bg-dark bg-opacity-10">
      <label className="form-label text-uppercase">OPENING HOURS</label>
      {hours.map((hour, index) => (
        <div key={index} className="row align-items-center mb-2">
          <div className="col-5">
            <PickTime
              config={{
                value: hour.startTime,
                onChange: (time) => handleTimeChange(index, "startTime", time),
              }}
            />
          </div>
          <div className="col-5">
            <PickTime
              config={{
                value: hour.endTime,
                onChange: (time) => handleTimeChange(index, "endTime", time),
              }}
            />
          </div>
          <div className="col-2 text-end">
            <button
              onClick={() => handleRemoveTimeRange(index)}
              style={{
                background: "none",
                border: "none",
                color: "#240c73",
              }}
            >
              <i className="fa fa-times-circle"></i>
            </button>
          </div>
        </div>
      ))}

      <div className="row align-items-center mb-2">
        <div className="col-5">
          <button
            type="button"
            className="btn btn-gray btn-outline-gray bg-white mt-3"
            onClick={handleAddTimeRange}
          >
            Add option
          </button>
        </div>
      </div>
    </div>
  );
};

export default BusinessHour;
